import React from "react";
import { Switch } from "react-router-dom";
import { Layout } from "antd";
import Sider from "../layout/sider";
import Header from "../layout/header";
import { authenticatedRoutes } from "../../configs/routes/authenticatedRoutes";
import ProtectedRoute from "../shared/ProtectedRoute";
import LayoutSectionContent from "../layout/content/LayoutSectionContent";
import LayoutMainContent from "../layout/content/LayoutMainContent";
import IdleUserModalContainer from "../shared/idle/IdleUserModalContainer";
import LogoutConfirmModalContainer from "../shared/auth/LogoutConfirmModalContainer";
import RedirectHome from "./RedirectHome";
const routes = authenticatedRoutes.map(route => <ProtectedRoute key={route.path} {...route} exact/>);
const AuthenticatedApp = () => <>
  <Layout>
    <Header />
    <LayoutSectionContent>
      <Sider />
      <LayoutMainContent>
        <Switch>
          {routes}
          <RedirectHome />
        </Switch>
      </LayoutMainContent>
    </LayoutSectionContent>
  </Layout>
  <IdleUserModalContainer />
  <LogoutConfirmModalContainer />
</>;
export default AuthenticatedApp;
